"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
var react_1 = require("react");
var ModalContext = react_1.createContext({
    windows: [],
    addWindows: function () { },
    removeWindows: function () { },
    setActiveWindow: function () { },
    activeWindow: '',
});
exports.default = ModalContext;
//# sourceMappingURL=ModalContext.js.map